import ProfileSubstitutesTab from '@/features/profile/ProfileSubstitutesTab';

const TextModules = () => (
  <ProfileSubstitutesTab
    type="text_module"
    mode="text_module"
    titleKey="profile.tabs.textModules"
    descriptionKey="profile.textModules.description"
    addButtonKey="profile.textModules.addButton"
  />
);

export default TextModules;
